import { TImage } from "~/types";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import {
  CreateMultipleImagesDto,
  GetImagesParams,
  ImageParams,
} from "./image.types";

export const imageServices = {
  getImages: async (params?: GetImagesParams) => {
    const { data } = await baseService.get<PaginationResponse<TImage>>(
      "/images",
      {
        params,
      }
    );
    return data;
  },

  getImage: async (id: string) => {
    const { data } = await baseService.get<TImage>(`/images/${id}`);
    return data;
  },

  getMyImages: async (params?: GetImagesParams) => {
    const { data } = await baseService.get<PaginationResponse<TImage>>(
      "/images/my-image",
      {
        params,
      }
    );
    return data;
  },
  createImage: async (imageData: FormData) => {
    const { data } = await baseService.post<TImage>("/images", imageData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },

  createImages: async (dto: CreateMultipleImagesDto) => {
    const formData = new FormData();

    // Append files to formData with the key "files"
    dto.images.forEach((item, index) => {
      if (item.file) {
        formData.append(`images[${index}][file]`, item.file);
      }

      if (item.name) formData.append(`images[${index}][name]`, item.name);
      if (item.inventoryId)
        formData.append(`images[${index}][inventoryId]`, item.inventoryId);
      if (item.staffId)
        formData.append(`images[${index}][staffId]`, item.staffId);
      if (item.size)
        formData.append(`images[${index}][size]`, item.size.toString());
      if (item.url) formData.append(`images[${index}][url]`, item.url);
    });

    const { data } = await baseService.post<TImage>(
      "/images/multiple",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  },

  updateImage: async ({ id, ...imageData }: ImageParams & { id: string }) => {
    const formData = new FormData();

    Object.entries(imageData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (key === "file" && value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, String(value));
        }
      }
    });

    const { data } = await baseService.patch<TImage>(
      `/images/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  },

  deleteImage: async (id: string) => {
    const { data } = await baseService.delete(`/images/${id}`);
    return data;
  },
};
